import APITemplate from '@/api/APITemplate'

export default APITemplate('/device-command-task')
